<template>
  <div class="S603">
    <Logo :parentData="pageData"/>
    <BackStageMenu :parentData="pageData"/>
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>{{pageData.MenuName}}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tr>
                <td>使用者帳號</td>
                <td><input type="text" size="20" maxlength="40" v-model="form.ID"/></td>
                <td>狀態</td>
                <td>
                  <label>
                    <input type="radio" value="" checked="checked" v-model="form.ReturnCcode"/>
                    全部</label
                  >
                  <label>
                    <input
                      type="radio"
                      name="RadioGroup1"
                      value="0"
                      v-model="form.ReturnCcode"
                    />
                    正常</label
                  >
                  <label>
                    <input
                      type="radio"
                      name="RadioGroup1"
                      value="1"
                      v-model="form.ReturnCcode"
                    />
                    異常</label
                  >
                </td>
              </tr>
              <tr>
                <td>程式代碼/名稱</td>
                <td><input type="text" size="20" maxlength="20" v-model="form.PrgName"/></td>
              </tr>
              <tr>
                <td>日期區間</td>
                <td colspan="3">
                  <p>
                    <DatePicker
                      v-model="form.LoginTimeS"
                      format="YYYYMMDD"
                      :isTaiwanYear="false"
                      clearable
                      :disabled-date="disabledLoginTimeS"
                      placeholder="請輸入/選擇日期"/>
                    至
                    <DatePicker
                      v-model="form.LoginTimeE"
                      format="YYYYMMDD"
                      :isTaiwanYear="false"
                      clearable
                      :disabled-date="disabledLoginTimeE"
                      placeholder="請輸入/選擇日期"/>
                    <br />
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="submit"
                        class="btn"
                        value="查詢"
                        @click="() => { this.form.currentpage = 1; this.form.pagesize = 10; this.doQuery()}"
                      />
                      <!-- <input
                        type="submit"
                        class="btn"
                        value="匯出"
                        @click="doPrint()"
                      /-->
                      </span>
                  </label>
                </td>
              </tr>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table width="100%">
            <tbody>
              <tr v-if="grid.paginaiton">
                <td align="right">
                  <input
                    type="button"
                    value="<<"
                    class="btn"
                    style="height: 28px"
                    @click="form.currentpage = grid.paginaiton.pageNo - 1"
                    v-show="grid.paginaiton.pageNo > 1"
                  />
                  <span
                    v-for="(data, index) in grid.paginaiton.pages"
                    :key="index"
                    style="cursor: pointer"
                    :style="
                      grid.paginaiton.pageNo == data
                        ? 'color:red'
                        : 'color:black'
                    "
                    @click="form.currentpage = parseInt(data)"
                  >
                    {{
                      grid.paginaiton.pageNo == data ? "[" + data + "]" : data
                    }}
                  </span>
                  <input
                    type="button"
                    class="btn"
                    value=">>"
                    style="height: 28px"
                    v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                    @click="form.currentpage = grid.paginaiton.pageNo + 1"
                  />
                  ［每頁<input
                    type="text"
                    v-model.number.lazy="form.pagesize"
                    size="2"
                    maxlength="4"
                  />

                  <input type="button" class="btn" value="筆" />，第<input
                    type="text"
                    v-model.number.lazy="form.currentpage"
                    size="2"
                    maxlength="4"
                  />
                  <input type="button" class="btn" value="頁" />，共
                  {{ grid.paginaiton.totalPage }} 頁
                  {{ grid.paginaiton.totalCount }} 筆］
                </td>
              </tr>
            </tbody>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th>日期時間</th>
                    <th>登入IP</th>
                    <th>使用者帳號</th>
                    <th>程式名稱</th>
                    <th>功能名稱</th>
                    <th>狀態</th>
                    <th>訊息</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td>{{data.time}}</td>
                    <td>{{data.ip}}</td>
                    <td>{{data.id}}</td>
                    <td>{{data.prgName}}</td>
                    <td>{{data.actCd}}</td>
                    <td>{{data.returnCodeText}}</td>
                    <td>{{data.actLog}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
      <!-- 頁籤結束 -->
    </div>
    <PdisFooter />
    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import VueDatepicker from "@/components/Common/VueDatepickerLocal";
import Logo from '@/components/Common/Logo.vue';
import BackStageMenu from '@/components/BackStage/BackStageMenu.vue';
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { getMenuIndex,getMenu,logOut } from "@/config/util.js";
import {
  S603_SearchGrid
} from "@/service/api.js";
export default {
  name: 'S603',
  data: function(){
    return {
      pageData : {
        MenuIndex: 9,
        MenuName: "",
        PrgName: "S603",
        ServiceUnit: "PDIS",
        isForceLoginOut : true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      form: {
        ID:"",
        ReturnCcode:"",
        LoginTimeS:"",
        LoginTimeE:"",
        PrgName:"",
        sysType:"1",
        pagesize: 10,
        currentpage: 1,
      },
      grid: [],
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
    }
  },
  components:{
    Logo,
    BackStageMenu,
    PdisFooter,
    DatePicker: VueDatepicker,
    Alert: VueModal,
  },
   methods: {
    disabledLoginTimeS: function(time){
      if(this.form.LoginTimeE){
        return time > this.form.LoginTimeE;
      }
      return false;
    },
    disabledLoginTimeE: function(time){
      if(this.form.LoginTimeS){
        return time < this.form.LoginTimeS;
      }
      return false;
    },
    doQuery: function () {
      const self = this;
      if(!self.checkPage(self.form.currentpage , self.form.pagesize)) return;
      let postData = {
        serviceUnit: self.pageData.ServiceUnit,
        ID:self.form.ID,
        ReturnCcode:self.form.ReturnCcode,
        PrgName:self.form.PrgName,
        LoginTimeS:self.form.LoginTimeS,
        LoginTimeE:self.form.LoginTimeE,
        sysType: "1",
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      S603_SearchGrid(postData).then((rData) => {
        if(rData.result){
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit,self);
          };
        }
      });
    },
    //分頁防呆檢查
    checkPage: function(currentpage,pagesize){
      const self = this;
      let pageErrorMsg = [];
      if(currentpage){
        if(isNaN(parseInt(currentpage))){
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if(pagesize){
        if(isNaN(parseInt(pagesize))){
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if(pageErrorMsg.length){
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
  },
  watch: {
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.doQuery();
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.doQuery();
      }
    },
  },
  created(){
      const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if(Menu){
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    }
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
